import { Modal } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import s from './styles';

function InfoModal({
  width = 428,
  height = 234,
  titleAlert,
  info1,
  info2,
  onclick,
  error,
  ...props
}) {
  const { t } = useTranslation();

  const [realInfo1, realInfo2] = useMemo(() => [
    info1 || t('components.common.ErrorModal.somethingWentWrong'),
    info2 || error?.message,
  ], [info1, t, info2, error?.message]);

  return (
    <Modal
      {...props}
      transitionName=""
      width={width}
      height={height}
      centered
      footer={null}
      bodyStyle={{ padding: 0, overflow: 'auto' }}
      closable={false}
      maskStyle={{ backdropFilter: 'blur(10px)' }}
      visible
    >
      <s.Wrapper>
        <s.Title>
          {titleAlert || t('components.common.ErrorModal.error')}
        </s.Title>
      </s.Wrapper>

      <s.WrapperContents>
        {!!realInfo1 && <s.info>{realInfo1}</s.info>}
        {!!realInfo2 && <s.info>{realInfo2}</s.info>}
      </s.WrapperContents>

      <s.Line />

      <s.WrapperButtons>
        <s.Button onClick={onclick}>
          {t('components.common.ErrorModal.accept')}
        </s.Button>
      </s.WrapperButtons>
    </Modal>
  );
}

export default InfoModal;
